import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
function ModelBox({data}) {
    
    useEffect(()=>{
        setShow(data.show)
    },[data])

    const [show, setShow] = useState(false);
    
    const handleClose = () => {
        setShow(false);
        const { onClose } = data
        if( typeof data.onClose === "function"){
            onClose()
        }    
    };
    //const handleShow = () => setShow(true);
    return (
        <>
        <Modal 
            size={data.size}
            aria-labelledby="contained-modal-title-vcenter"
            centered      
            show={show} 
            onHide={handleClose}>
            <Modal.Header>
                <Modal.Title>{data.title}</Modal.Title>
            </Modal.Header>
            { data.content }
        </Modal>
        </>
    );
}

export default ModelBox